import React from 'react';
import { Section } from '../ui/Section';
import { Button } from '../ui/Button';
import { Check, Star } from 'lucide-react';
export function Pricing() {
  return <Section className="bg-dark-800 relative" id="pricing" data-id="element-197">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[300px] bg-gold-600/10 blur-[120px] pointer-events-none" data-id="element-198" />

      <div className="text-center mb-16 relative z-10" data-id="element-199">
        <h2 className="text-4xl md:text-5xl font-black text-white mb-6" data-id="element-200">
          ⏰ PRECIO DE LANZAMIENTO
        </h2>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-xl font-bold" data-id="element-201">
          <span className="text-red-400 bg-red-400/10 px-4 py-2 rounded-lg" data-id="element-202">
            ⚠️ Después sube y no vuelve
          </span>
          <span className="text-gold-400 bg-gold-400/10 px-4 py-2 rounded-lg" data-id="element-203">
            🔴 Cupos limitados
          </span>
        </div>
      </div>

      <div className="grid lg:grid-cols-2 gap-8 max-w-5xl mx-auto relative z-10" data-id="element-204">
        {/* Tier 1 */}
        <div className="bg-dark-900 border border-dark-700 rounded-3xl p-8 flex flex-col" data-id="element-205">
          <div className="mb-8" data-id="element-206">
            <h3 className="text-2xl font-black text-white mb-4" data-id="element-207">
              📘 MEGA PACK REVENTA PRO
            </h3>
            <p className="text-gray-400 text-lg mb-6" data-id="element-208">6 Tomos + 6 Bonos</p>
            <div className="inline-block bg-dark-800 text-gray-300 px-4 py-2 rounded-lg font-medium text-sm mb-8" data-id="element-209">
              Ideal para: empezar desde cero
            </div>
            <div className="flex items-baseline gap-3" data-id="element-210">
              <span className="text-2xl text-gray-500 line-through font-bold" data-id="element-211">
                $49.000
              </span>
              <span className="text-5xl font-black text-white" data-id="element-212">
                $19.990 <span className="text-xl text-gray-400" data-id="element-213">ARS</span>
              </span>
            </div>
          </div>

          <div className="mt-auto pt-8" data-id="element-214">
            <Button variant="outline" fullWidth size="lg" href="https://checkout.cmdigitalpro.online/cart/54042050461980:1" data-id="element-215">
              ELEGIR MEGA PACK
            </Button>
          </div>
        </div>

        {/* Tier 2 - Highlighted */}
        <div className="bg-dark-900 border-2 border-gold-500 rounded-3xl p-8 flex flex-col relative transform lg:-translate-y-4 shadow-gold-glow-lg" data-id="element-216">
          <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-gold-gradient text-black font-bold px-6 py-2 rounded-full text-sm flex items-center gap-2 whitespace-nowrap" data-id="element-217">
            <Star className="w-4 h-4 fill-current" data-id="element-218" /> MÁS ELEGIDO
          </div>

          <div className="mb-8" data-id="element-219">
            <h3 className="text-2xl font-black text-white mb-4 flex items-center gap-2" data-id="element-220">
              🚀 MEGA PACK + SISTEMA PLUG & PLAY
            </h3>
            <p className="text-gold-400 font-bold mb-2" data-id="element-221">
              + Sistema de Ingresos Automatizados ⭐
            </p>
            <p className="text-gray-400 text-lg mb-6" data-id="element-222">
              6 Tomos + 6 Bonos + sistema listo para vender
            </p>
            <div className="inline-block bg-gold-500/20 text-gold-300 px-4 py-2 rounded-lg font-medium text-sm mb-8" data-id="element-223">
              Ideal para: resultados MÁS RÁPIDO
            </div>
            <div className="flex items-baseline gap-3" data-id="element-224">
              <span className="text-2xl text-gray-500 line-through font-bold" data-id="element-225">
                $79.000
              </span>
              <span className="text-5xl font-black text-transparent bg-clip-text bg-gold-gradient" data-id="element-226">
                $27.990 <span className="text-xl text-gold-600" data-id="element-227">ARS</span>
              </span>
            </div>
          </div>

          <div className="mt-auto pt-8" data-id="element-228">
            <Button fullWidth size="xl" className="animate-pulse-slow" href="https://checkout.cmdigitalpro.online/cart/54042053411100:1" data-id="element-229">
              👉 QUIERO EL SISTEMA COMPLETO
            </Button>
          </div>
        </div>
      </div>
    </Section>;
}